<script>import { RemoteIcon } from "@infinitro/icons";
import { icon, iconActive, iconHover } from "./colors";
export let size = 20;
export let active = false;
export let hover = false;
export let color = void 0;
let fill = color ? color : active ? iconActive : hover ? iconHover : icon;
$: fill = color ? color : active ? iconActive : hover ? iconHover : icon;
</script>

<div class="svg-container">
	<div class="ripple-container">
		<svg
			fill="none"
			height="100"
			viewBox="0 0 100 100"
			width="100"
			xmlns="http://www.w3.org/2000/svg"
		>
			<defs>
				<radialGradient id="grad-soft" cx="50%" cy="50%" r="50%">
					<stop offset="0%" stop-color="#FFF7B0" stop-opacity="1" />
					<stop offset="60%" stop-color="#FFD60A" stop-opacity="0.9" />
					<stop offset="100%" stop-color="#EDAC3B" stop-opacity="0.3" />
				</radialGradient>

				<filter id="soft-blur" x="-50%" y="-50%" width="200%" height="200%">
					<feGaussianBlur stdDeviation="4" result="b" />
					<feComponentTransfer>
						<feFuncA type="linear" slope="1.4" />
					</feComponentTransfer>
				</filter>
			</defs>

			<circle class="ripple" cx="50" cy="50" r="0" filter="url(#soft-blur)" />
		</svg>
	</div>

	<div class="icon-wrapper">
		<RemoteIcon icon={'ReferralIconAnimated'} {size} bind:hover {active} />
	</div>
</div>

<style>
	@keyframes ripple {
		0% {
			r: 0;
			opacity: 1;
		}
		100% {
			r: 25;
			opacity: 0;
		}
	}

	.svg-container {
		position: relative;
		display: inline-block;
		width: -moz-fit-content;
		width: fit-content;
		height: -moz-fit-content;
		height: fit-content;
	}

	.ripple-container {
		position: absolute;
		width: 100px;
		height: 100px;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		pointer-events: none;
		z-index: 0;
	}

	.ripple {
		fill: url(#grad-soft);
		animation: ripple 2s infinite;
		transform-origin: center;
	}

	.icon-wrapper {
		position: relative;
		z-index: 1;
	}
</style>
